import { __generator } from "tslib";
import { takeLatest, call, select } from 'redux-saga/effects';
import { fetchFreshDeviations } from './actionCreators';
import { isApiError, request } from '../../../xhr';
import { getPrimaryTier, isDeviationAuthor, } from '../../../DeviationViews/_helpers';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { getCurrentUser } from '../../../publicSession/selectors';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        var deviations = require('@wix/da-sample-data').deviationsByType.image;
        return { deviations: deviations.slice(0, 24) };
    }
}
function fetchDeviations(deviationIds) {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: "/deviation/multifetch",
                    params: {
                        deviationids: deviationIds.slice(0, 24),
                    },
                }, fakeResponse)];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
export function doFetchFresh(action) {
    var _a, deviationIds, setEntityData, currentUser, result, deviations;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, deviationIds = _a.deviationIds, setEntityData = _a.setEntityData;
                return [4 /*yield*/, select(getCurrentUser)];
            case 1:
                currentUser = _b.sent();
                return [4 /*yield*/, call(fetchDeviations, deviationIds)];
            case 2:
                result = _b.sent();
                if (result && result.deviations && !isApiError(result)) {
                    deviations = result.deviations
                        .map(function (deviation) {
                        var isInTier = getPrimaryTier(deviation);
                        var isOwner = isDeviationAuthor(deviation, currentUser);
                        var isPremium = normalizePremiumFolderData(deviation.premiumFolderData).isPremium;
                        var isForbidden = isPremium || (isInTier && !isOwner);
                        if (!isForbidden) {
                            return deviation;
                        }
                        return undefined;
                    })
                        .filter(function (i) { return i !== undefined; });
                    if (deviations.length) {
                        return [2 /*return*/, setEntityData(deviations)];
                    }
                }
                setEntityData(undefined);
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(fetchFreshDeviations, doFetchFresh)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map